"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.booleanDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var booleanDependencies = exports.booleanDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createBoolean: _factoriesAny.createBoolean
};